import React from 'react'
import { Trans, useTranslation } from 'react-i18next'
import { BpButton } from '../../buttons/bp-button/BpButton'
import { useAppDispatch, useAppSelector } from '../../../../store/hooks/Redux'
import { NavLink, useNavigate } from 'react-router-dom'
import { selectDemoProject, setShowGuide } from '../../../../store/reducers/AppSlice'

export const ProjectStub = () => {
  const { t } = useTranslation()
  const demoProject = useAppSelector(selectDemoProject)
  const dispatch = useAppDispatch()

  return (
    <div className={'flex flex-wrap py-[55px] justify-center gap-[65px] px-[24px]'}>
      <div className={'-mt-[11px]'}>
        <svg
          className={'w-[144px]'}
          fill='none'
          viewBox='0 0 144 144'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path
            clipRule='evenodd'
            d='M20.4694 61.7931C25.2809 34.9061 48.7816 14.5 77.0364 14.5C108.776 14.5 134.505 40.2436 134.505 72C134.505 103.756 108.776 129.5 77.0364 129.5C72.5674 129.5 68.2229 128.99 64.0557 128.028C61.6354 127.469 59.2205 128.979 58.6618 131.401C58.1032 133.822 59.6124 136.239 62.0327 136.798C66.8587 137.912 71.8818 138.5 77.0364 138.5C113.744 138.5 143.501 108.727 143.501 72C143.501 35.2731 113.744 5.5 77.0364 5.5C44.3489 5.5 17.1808 29.1051 11.6151 60.2069C11.1773 62.6533 12.8045 64.9915 15.2496 65.4296C17.6947 65.8676 20.0317 64.2395 20.4694 61.7931ZM84.9297 76C83.5464 78.3912 80.9611 80 77.9999 80C73.5816 80 69.9999 76.4183 69.9999 72C69.9999 69.0389 71.6087 66.4535 73.9999 65.0703V40C73.9999 37.7909 75.7908 36 77.9999 36C80.2091 36 81.9999 37.7909 81.9999 40V65.0703C83.2144 65.7728 84.2271 66.7855 84.9297 68H110C112.209 68 114 69.7909 114 72C114 74.2091 112.209 76 110 76H84.9297ZM73.9999 24C73.9999 21.7909 75.7908 20 77.9999 20C80.2091 20 81.9999 21.7909 81.9999 24V25C81.9999 27.2091 80.2091 29 77.9999 29C75.7908 29 73.9999 27.2091 73.9999 25V24ZM77.9999 116C75.7908 116 73.9999 117.791 73.9999 120V121C73.9999 123.209 75.7908 125 77.9999 125C80.2091 125 81.9999 123.209 81.9999 121V120C81.9999 117.791 80.2091 116 77.9999 116ZM40.8772 41.0355C39.3151 39.4734 39.3151 36.9407 40.8772 35.3786C42.4393 33.8165 44.9719 33.8165 46.534 35.3786L47.2411 36.0857C48.8032 37.6478 48.8032 40.1805 47.2411 41.7426C45.679 43.3047 43.1464 43.3047 41.5843 41.7426L40.8772 41.0355ZM108.759 103.261C107.197 104.823 107.197 107.356 108.759 108.918L109.467 109.625C111.029 111.187 113.561 111.187 115.123 109.625C116.685 108.063 116.685 105.53 115.123 103.968L114.416 103.261C112.854 101.699 110.322 101.699 108.759 103.261ZM109.466 35.3753C111.029 33.8132 113.561 33.8132 115.123 35.3753C116.685 36.9374 116.685 39.4701 115.123 41.0322L114.416 41.7393C112.854 43.3014 110.321 43.3014 108.759 41.7393C107.197 40.1772 107.197 37.6445 108.759 36.0824L109.466 35.3753ZM130.5 72.5C130.5 70.2909 128.709 68.5 126.5 68.5H125.5C123.291 68.5 121.5 70.2909 121.5 72.5C121.5 74.7091 123.291 76.5 125.5 76.5H126.5C128.709 76.5 130.5 74.7091 130.5 72.5Z'
            fill='#00326D'
            fillRule='evenodd'
          />
          <path
            clipRule='evenodd'
            d='M5 73C2.79086 73 1 74.7909 1 77C1 79.2091 2.79086 81 5 81H40C42.2091 81 44 79.2091 44 77C44 74.7909 42.2091 73 40 73H5ZM13 88C10.7909 88 9 89.7909 9 92C9 94.2091 10.7909 96 13 96H48C50.2091 96 52 94.2091 52 92C52 89.7909 50.2091 88 48 88H13ZM1 107C1 104.791 2.79086 103 5 103H40C42.2091 103 44 104.791 44 107C44 109.209 42.2091 111 40 111H5C2.79086 111 1 109.209 1 107ZM13 118C10.7909 118 9 119.791 9 122C9 124.209 10.7909 126 13 126H48C50.2091 126 52 124.209 52 122C52 119.791 50.2091 118 48 118H13Z'
            fill='#85FF3B'
            fillRule='evenodd'
          />
        </svg>
      </div>
      {demoProject ? (
        <div className={'max-w-[485px] select-none'}>
          <h2 className={'text-[36px] leading-[48px] pb-[16px] hidden md:block'}>
            {t('components.projectStub.preparingYourData')}
          </h2>
          <p className={'text-[15px] pb-[16px]'}>
            <span
              dangerouslySetInnerHTML={{
                __html: t('components.projectStub.gatheringDataNow'),
              }}
            />{' '}
            <Trans i18nKey='components.projectStub.ifNoData'>
              <span
                className={'text-default cursor-pointer'}
                onClick={() => dispatch(setShowGuide())}
              />
            </Trans>
          </p>
          <p className={'text-[15px] pb-[16px]'}>
            {t('components.projectStub.checkOutSampleReport')}
          </p>
          <BpButton
            size={'sm'}
            onClick={() => (window.location.href = `?project=${demoProject.value}`)}
          >
            {t('components.projectStub.viewSampleReport')}
          </BpButton>
        </div>
      ) : (
        <div className={'max-w-[485px] select-none'}>
          <h2 className={'text-[36px] leading-[48px] pb-[16px] hidden md:block'}>
            {t('components.projectStub.preparingYourData')}
          </h2>
          <p className={'text-[15px] pb-[16px]'}>
            <span
              dangerouslySetInnerHTML={{
                __html: t('components.projectStub.gatheringDataNow'),
              }}
            />
            {t('components.projectStub.onceReady')}
          </p>
          <p className={'text-[15px] pb-[16px]'}>
            <Trans i18nKey='components.projectStub.ifNoData'>
              <span />
            </Trans>
          </p>
          <BpButton size={'sm'} onClick={() => dispatch(setShowGuide())}>
            {t('components.projectStub.askOurTeam')}
          </BpButton>
        </div>
      )}
    </div>
  )
}
